export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/assets/pool-hero.jpg"
          alt="Sikaiadah Newton"
          className="w-full h-full object-cover object-[55%_top] sm:object-[60%_top] lg:object-[62%_15%]"
        />
        <div className="absolute inset-0 hero-vignette"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-10 pt-40 lg:pt-44 pb-24 min-h-[100vh] flex flex-col justify-between">
        <div className="max-w-3xl">
          <p
            data-testid="hero-eyebrow"
            className="fade-up text-[11px] sm:text-xs tracking-[0.4em] uppercase text-classy-soft/90 mb-6"
          >
            Norfolk · Ward 3 · 2026
          </p>

          <h1
            data-testid="hero-title"
            className="fade-up font-serif-display text-lavender text-[88px] sm:text-[120px] lg:text-[180px] xl:text-[220px] leading-[0.85] font-medium"
          >
            Vote
            <br />
            <span className="italic font-light text-[78px] sm:text-[110px] lg:text-[170px] xl:text-[210px]">
              for
            </span>{" "}
            <span className="font-semibold">Si</span>
          </h1>

          <div className="fade-up-2 mt-8 lg:mt-10">
            <div className="flex items-center gap-4 mb-3">
              <div className="h-px w-10 bg-lavender/70"></div>
              <p className="text-[12px] sm:text-sm tracking-[0.32em] uppercase text-lavender font-medium">
                Sikaiadah Newton
              </p>
            </div>
            <p className="text-[11px] sm:text-xs tracking-[0.28em] uppercase text-lavender-soft mb-7 ml-14">
                For City Council — Ward 3
            </p>
            <p className="font-serif-display italic text-2xl sm:text-3xl lg:text-4xl text-lavender">
              Community Is Our Power.
            </p>
          </div>

          <div className="fade-up-3 mt-10 lg:mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#about"
              data-testid="hero-cta-learn"
              className="btn-classy px-8 py-4 rounded-full text-xs uppercase inline-flex items-center justify-center"
            >
              Learn More
            </a>
            <a
              href="#get-involved"
              data-testid="hero-cta-involved"
              className="btn-outline-classy px-8 py-4 rounded-full text-xs uppercase inline-flex items-center justify-center"
            >
              Get Involved
            </a>
            <a
              href="https://www.zeffy.com/en-US/donation-form/community-is-our-power"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-donate"
              className="btn-classy px-8 py-4 rounded-full text-xs uppercase inline-flex items-center justify-center"
            >
              Donate
            </a>
          </div>
        </div>

        {/* Scroll cue */}
        <div className="fade-up-4 hidden lg:flex items-center gap-3 mt-10">
          <div className="h-12 w-px bg-classy/50"></div>
          <span className="text-[10px] tracking-[0.32em] uppercase text-classy-soft">
            Scroll to discover
          </span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
